import { convertToDate, slugify, interpolate, deviceChange, isMobileQuery, configQuery, getFeatureEnabled, formatDate, toUtc, formatTime, formatCurrency, FeatureEnabledV2, getItemDate, getItemTime, formatTimeUTC, MagicConfigMixin, ContentMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Component, Mixins } from 'vue-property-decorator';
import { Feature } from '@gig/magic-messages';
import { CoreXMediatorType } from '@gig/magic-sdk/dist/adapter/responsiblegaming/createUserTransactionLimit';
import { TRANSACTIONS_NAMESPACE } from '../../store/modules/transactions/transactions.store.js';
import { store } from '../../store/index.js';
import { namespace } from 'vuex-class';
import { printContent } from '../../config/print-content.js';
import { PaymentTransactionColumn } from '@gig/magic-wallet-types';
import { CoreXTransacationStatus, CoreXOperationType } from '@gig/magic-sdk/dist/adapter/users/getUserTransactionsHistory';
import { getOldestTransactionDate } from '../../utils/transactions.js';

// magic-corex-payment-transactions
var PaymentHistoryType;
(function (PaymentHistoryType) {
    PaymentHistoryType["WITHDRAWAL"] = "withdrawals";
    PaymentHistoryType["DEPOSIT"] = "deposits";
    PaymentHistoryType["ALL_PAYMENT_TRANSACTIONS"] = "all_payment_transactions";
})(PaymentHistoryType || (PaymentHistoryType = {}));
var transactions = namespace(TRANSACTIONS_NAMESPACE);
/**
 * Fetches and displays the list of payment transactions
 */
var PaymentTransactionsComponent = /** @class */ (function (_super) {
    __extends(PaymentTransactionsComponent, _super);
    function PaymentTransactionsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Allow template to access this enum
        _this.Column = PaymentTransactionColumn;
        /**
         * List of columns that should be displayed.
         * This property does not affect the order.
         * Default values = 'status-icon,type,date,time,amount,provider'
         * @see PaymentTransactionColumn
         */
        _this.columns = 'status-icon,type,date,time,amount,provider,info';
        /**
         * To show print link.
         */
        _this.showPrintPaymentHistory = false;
        /**
         * When enabled it will use alternative layout for the
         * payment transaction history in wallet, initially loading 30
         * items. Logic has been moved to async created to avoid reactivity
         * issues.
         */
        _this.paymentTransactionAlternativeLayout = false;
        _this.starting = 0;
        _this.size = 0;
        _this.isMobile = false;
        /**
         * When enabled it will show advanced status in the
         * payment transaction history in wallet. It will have
         * colored icons for different statuses, and it will
         * display the text Success, Failed, Approved etc.
         */
        _this.statusPaymentTransactions = false;
        /**
         * When enabled it will show the time and date
         * in local time instead of UTC.
         */
        _this.isLocalTime = false;
        _this.scrollToBottomOfPayment = function () {
            setTimeout(function () {
                var gamingElement = _this.$refs.history;
                gamingElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }, 50);
        };
        return _this;
    }
    Object.defineProperty(PaymentTransactionsComponent.prototype, "fromDate", {
        get: function () {
            return convertToDate(this.from);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentTransactionsComponent.prototype, "toDate", {
        get: function () {
            return convertToDate(this.to);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentTransactionsComponent.prototype, "shownColumns", {
        get: function () {
            return this.columns.split(',').map(function (str) {
                return str.trim();
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentTransactionsComponent.prototype, "hasMoreRows", {
        get: function () {
            return this.size < this.total;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentTransactionsComponent.prototype, "shownHistory", {
        get: function () {
            var _this = this;
            var _a;
            return (_a = this.transactions) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                return {
                    id: item.TransactionId,
                    date: new Date(item.TimestampEpoch),
                    statusIcon: _this.getStatus(item.Payload.Transaction.Current.Status),
                    type: "payment-transactions.payment-type." + _this.convertHistoryType(item.Payload.OperationType),
                    method: _this.getPaymentMethod(item.Payload.Transaction.Current.AdditionalProperties),
                    status: "payment-transactions.status." + slugify(item.Payload.Transaction.Current.Status),
                    amount: item.Payload.Amount,
                    balance: item.Payload.Transaction.Current.BalanceAmount,
                    transactionType: _this.convertHistoryType(item.Payload.OperationType),
                    transactionTitle: _this.getStatusTranslation(item.Payload.Transaction.Current.Status),
                    currency: item.Payload.CurrencyCode,
                    idLabel: _this.getIdLabel(item),
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    PaymentTransactionsComponent.prototype.getIdLabel = function (item) {
        var _a, _b, _c, _d;
        var properties = item.Payload.Transaction.Current.AdditionalProperties;
        var propObject = JSON.parse(properties);
        var correlationLabel = interpolate(this.$t('transactions.correlation-id.header'), {
            id: (_b = (_a = propObject === null || propObject === void 0 ? void 0 : propObject.Payments) === null || _a === void 0 ? void 0 : _a.Transaction) === null || _b === void 0 ? void 0 : _b.CorrelationId,
        });
        var correlationText = ((_d = (_c = propObject === null || propObject === void 0 ? void 0 : propObject.Payments) === null || _c === void 0 ? void 0 : _c.Transaction) === null || _d === void 0 ? void 0 : _d.CorrelationId)
            ? "\n        " + correlationLabel
            : '';
        var resultText = '' +
            interpolate(this.$t('sweepx-transactions.id.header'), {
                id: item.TransactionId,
            }) +
            correlationText;
        return resultText;
    };
    PaymentTransactionsComponent.prototype.getOldestPaymentTransactionDate = function () {
        if (!this.transactions || this.transactions.length === 0) {
            return;
        }
        var oldestDate = getOldestTransactionDate(this.transactions);
        this.$emit('update-from-date', oldestDate);
    };
    PaymentTransactionsComponent.prototype.getStatusTranslation = function (status) {
        if (status === CoreXTransacationStatus.NEW) {
            return 'payment-transactions.payment-type.new';
        }
        else if (status === CoreXTransacationStatus.PENDING_AUTHORIZATION) {
            return 'payment-transactions.payment-type.pending-authorization';
        }
        else if (status === CoreXTransacationStatus.PENDING_VALIDATION) {
            return 'payment-transactions.payment-type.pending-validation';
        }
        else if (status === CoreXTransacationStatus.PENDING_REVERSAL) {
            return 'payment-transactions.payment-type.pending-reversal';
        }
        else if (status === CoreXTransacationStatus.AUTHORIZED) {
            return 'payment-transactions.payment-type.authorized';
        }
        else if (status === CoreXTransacationStatus.SUBMITTED) {
            return 'payment-transactions.payment-type.submitted';
        }
        else if (status === CoreXTransacationStatus.COMPLETED) {
            return 'payment-transactions.payment-type.completed';
        }
        else if (status === CoreXTransacationStatus.REJECTED) {
            return 'payment-transactions.payment-type.rejected';
        }
        else if (status === CoreXTransacationStatus.CANCELED) {
            return 'payment-transactions.payment-type.canceled';
        }
        else if (status === CoreXTransacationStatus.DECLINED) {
            return 'payment-transactions.payment-type.declined';
        }
        else if (status === CoreXTransacationStatus.REVERSED) {
            return 'payment-transactions.payment-type.reversed';
        }
        else if (status === CoreXTransacationStatus.FAILED) {
            return 'payment-transactions.payment-type.failed';
        }
        else {
            return 'payment-transactions.payment-type.failed';
        }
    };
    PaymentTransactionsComponent.prototype.convertHistoryType = function (type) {
        switch (type) {
            case CoreXOperationType.DEBIT:
                return PaymentHistoryType.WITHDRAWAL;
            case CoreXOperationType.CREDIT:
                return PaymentHistoryType.DEPOSIT;
            default:
                // No other types are documented but just in case we
                // do not want to match these.
                return '';
        }
    };
    PaymentTransactionsComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isAlternativeLayoutFeatureEnabled;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getFeatureEnabled(Feature.PAYMENT_TRANSACTION_HISTORY_ALTERNATIVE_LAYOUT)];
                    case 1:
                        isAlternativeLayoutFeatureEnabled = _a.sent();
                        if (isAlternativeLayoutFeatureEnabled) {
                            this.paymentTransactionAlternativeLayout = true;
                        }
                        // Set size after paymentTransactionAlternativeLayout is updated
                        if (this.paymentTransactionAlternativeLayout) {
                            this.size = 30;
                        }
                        else if (this.typeFilter) {
                            this.size = 10;
                        }
                        else {
                            this.size = 5;
                        }
                        this.deviceSubscription = deviceChange(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _a = this;
                                        return [4 /*yield*/, isMobileQuery()];
                                    case 1:
                                        _a.isMobile = _b.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        configQuery('wallet.paymentHistoryColumns', function (columns) {
                            if (!columns) {
                                return;
                            }
                            var allValues = Object.values(PaymentTransactionColumn);
                            var areValidColumns = columns.every(function (column) {
                                return allValues.includes(column.trim());
                            });
                            if (areValidColumns) {
                                _this.columns = columns.join(',');
                            }
                        });
                        configQuery('wallet.paymentHistoryPrintOption', function (value) {
                            _this.showPrintPaymentHistory = !!value;
                        });
                        this.fetchData();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentTransactionsComponent.prototype.destroyed = function () {
        var _a;
        (_a = this.deviceSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    PaymentTransactionsComponent.prototype.loadMore = function () {
        this.size += this.typeFilter ? 10 : 5;
        this.fetchData({
            loadMore: true,
            size: 5,
        });
    };
    PaymentTransactionsComponent.prototype.isColumnShown = function (column) {
        return this.shownColumns.includes(column);
    };
    PaymentTransactionsComponent.prototype.getStatus = function (status) {
        if (status === CoreXTransacationStatus.NEW) {
            return 'alert';
        }
        else if (status === CoreXTransacationStatus.PENDING_AUTHORIZATION) {
            return 'alert';
        }
        else if (status === CoreXTransacationStatus.PENDING_VALIDATION) {
            return 'alert';
        }
        else if (status === CoreXTransacationStatus.PENDING_REVERSAL) {
            return 'alert';
        }
        else if (status === CoreXTransacationStatus.AUTHORIZED) {
            return 'success';
        }
        else if (status === CoreXTransacationStatus.SUBMITTED) {
            return 'success';
        }
        else if (status === CoreXTransacationStatus.COMPLETED) {
            return 'success';
        }
        else if (status === CoreXTransacationStatus.CANCELED) {
            return 'error';
        }
        else if (status === CoreXTransacationStatus.REJECTED) {
            return 'error';
        }
        else if (status === CoreXTransacationStatus.DECLINED) {
            return 'error';
        }
        else if (status === CoreXTransacationStatus.REVERSED) {
            return 'success';
        }
        else if (status === CoreXTransacationStatus.FAILED) {
            return 'error';
        }
        else {
            return 'error';
        }
    };
    PaymentTransactionsComponent.prototype.getPaymentMethod = function (payload) {
        try {
            var PaymentMethod = JSON.parse(payload).Payments.Transaction.PaymentMethod;
            var translation = this.$t("payment-transactions.payment-method." + PaymentMethod.replaceAll(/\s/g, ''));
            return translation !== '' ? translation : PaymentMethod;
        }
        catch (_a) {
            return '-';
        }
    };
    PaymentTransactionsComponent.prototype.fetchData = function (_a) {
        var _b;
        var _c = _a === void 0 ? {} : _a, _d = _c.loadMore, loadMore = _d === void 0 ? false : _d, _e = _c.size, size = _e === void 0 ? this.size : _e;
        return __awaiter(this, void 0, void 0, function () {
            var depositsAndWithdrawalsTotalNumber, typeFilter, starting, e_1;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!this.from || !this.to) {
                            return [2 /*return*/];
                        }
                        depositsAndWithdrawalsTotalNumber = this.total || 5;
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 7, , 8]);
                        this.onContentLoadInit();
                        typeFilter = void 0;
                        if (this.typeFilter) {
                            typeFilter =
                                this.typeFilter === PaymentHistoryType.DEPOSIT
                                    ? CoreXOperationType.CREDIT
                                    : CoreXOperationType.DEBIT;
                        }
                        starting = loadMore
                            ? ((_b = this.transactions) === null || _b === void 0 ? void 0 : _b.length) || 0
                            : this.starting;
                        return [4 /*yield*/, this.fetchTransactions({
                                from: this.fromDate,
                                to: this.toDate,
                                size: size,
                                starting: starting,
                                mediatorType: CoreXMediatorType.MONETARY,
                                typeFilter: typeFilter,
                                loadMore: loadMore,
                            })];
                    case 2:
                        _f.sent();
                        if (!(this.typeFilter ===
                            PaymentHistoryType.ALL_PAYMENT_TRANSACTIONS &&
                            this.total)) return [3 /*break*/, 4];
                        this.size = depositsAndWithdrawalsTotalNumber;
                        return [4 /*yield*/, this.fetchTransactions({
                                from: this.fromDate,
                                to: this.toDate,
                                size: depositsAndWithdrawalsTotalNumber,
                                starting: starting,
                                mediatorType: CoreXMediatorType.MONETARY,
                                loadMore: loadMore,
                            })];
                    case 3:
                        _f.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        if (!(this.typeFilter && this.total)) return [3 /*break*/, 6];
                        this.size = this.total;
                        return [4 /*yield*/, this.fetchTransactions({
                                from: this.fromDate,
                                to: this.toDate,
                                size: this.size,
                                starting: starting,
                                mediatorType: CoreXMediatorType.MONETARY,
                                typeFilter: typeFilter,
                            })];
                    case 5:
                        _f.sent();
                        _f.label = 6;
                    case 6:
                        this.onContentLoad(this.transactions);
                        if (loadMore) {
                            this.scrollToBottomOfPayment();
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        e_1 = _f.sent();
                        this.onContentLoadError(e_1);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    PaymentTransactionsComponent.prototype.getMethodIcon = function (method) {
        // This method is based on current wallet information.
        // TODO: Improve this to cover more method types in a sensible
        // way. Eg. right now master card shows visa logo.
        var name = method.toLowerCase();
        if (/(envoy|entercash)/.test(name)) {
            return 'bank';
        }
        if (/(credit card|creditcard)/.test(name)) {
            return 'visa';
        }
        if (/moneybookers/.test(name)) {
            return 'skrill';
        }
        return slugify(method);
    };
    PaymentTransactionsComponent.prototype.printHistoryContent = function () {
        var rows = [];
        for (var _i = 0, _a = this.shownHistory; _i < _a.length; _i++) {
            var item = _a[_i];
            var currency = item.currency;
            rows.push("\n                <tr>\n                    <td>" + this.$t(item.transactionTitle) + "</td>\n                    <td>" + item.id + "</td>\n                    <td>" + this.$t("payment-transactions.payment-type." + item.transactionType) + "</td>\n                    <td>" + formatDate(toUtc(item.date)) + "</td>\n                    <td>" + formatTime(toUtc(item.date)) + "</td>\n                    <td>" + formatCurrency(item.amount, currency) + "</td>\n                    <td>" + formatCurrency(item.balance, currency) + "</td>\n                    <td>" + this.getMethodIcon(item.method).toUpperCase() + "</td>\n                </tr>\n            ");
        }
        var content = "\n            <style>\n                table { border-collapse: collapse; width: 100%; }\n                th, td { border: 1px solid black; padding: 0.25em; text-align: left; }\n                button { border: 1px solid black; color: black; font-size: 32px; margin: 0 10px; }\n                div { margin: 50px 0; text-align: center; }\n                @media print { button { display: none; } }\n            </style>\n            <table>\n                <thead>\n                    <tr>\n                        <th>" + this.$t('payment-transactions.status.header') + "</th>\n                        <th>" + this.$t('payment-transactions.id.header') + "</th>\n                        <th>" + this.$t('payment-transactions.transaction-type.header') + "</th>\n                        <th>" + this.$t('payment-transactions.date.header') + "</th>\n                        <th>" + this.$t('payment-transactions.time.header') + "</th>\n                        <th>" + this.$t('payment-transactions.amount.header') + "</th>\n                        <th>" + this.$t('payment-transactions.balance.header') + "</th>\n                        <th>" + this.$t('payment-transactions.provider-reference.header') + "</th>\n                    </tr>\n                </thead>\n                <tbody>\n                    " + rows.join('') + "\n                </tbody>\n            </table>\n        ";
        var buttons = "\n            <div>\n                <button onclick=\"window.print()\">" + this.$t('payment-transactions.print') + "</button>\n                <button onclick=\"window.close()\">" + this.$t('payment-transactions.close') + "</button>\n            </div>\n        ";
        printContent(content, buttons);
    };
    __decorate([
        Prop({
            type: [Number, String, Date],
        }),
        __metadata("design:type", Object)
    ], PaymentTransactionsComponent.prototype, "from", void 0);
    __decorate([
        Prop({
            type: [Number, String, Date],
        }),
        __metadata("design:type", Object)
    ], PaymentTransactionsComponent.prototype, "to", void 0);
    __decorate([
        Prop({
            type: String,
            validator: function (types) {
                if (!types) {
                    return true;
                }
                var found = types.split(',');
                var allValues = Object.values(PaymentHistoryType);
                return found.every(function (type) {
                    return allValues.includes(type.trim());
                });
            },
            default: '',
        }),
        __metadata("design:type", String)
    ], PaymentTransactionsComponent.prototype, "typeFilter", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.STATUS_PAYMENT_TRANSACTIONS,
        }),
        __metadata("design:type", Boolean)
    ], PaymentTransactionsComponent.prototype, "statusPaymentTransactions", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.TRANSACTIONS_HISTORY_ON_LOCAL_TIME,
        }),
        __metadata("design:type", Boolean)
    ], PaymentTransactionsComponent.prototype, "isLocalTime", void 0);
    __decorate([
        transactions.Getter('isLoadingState'),
        __metadata("design:type", void 0)
    ], PaymentTransactionsComponent.prototype, "isLoading", void 0);
    __decorate([
        transactions.Getter('getTransactions'),
        __metadata("design:type", void 0)
    ], PaymentTransactionsComponent.prototype, "transactions", void 0);
    __decorate([
        transactions.Getter('getTransactionsTotal'),
        __metadata("design:type", void 0)
    ], PaymentTransactionsComponent.prototype, "total", void 0);
    __decorate([
        transactions.Action('fetchTransactions'),
        __metadata("design:type", Object)
    ], PaymentTransactionsComponent.prototype, "fetchTransactions", void 0);
    __decorate([
        Watch('transactions', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PaymentTransactionsComponent.prototype, "getOldestPaymentTransactionDate", null);
    __decorate([
        Watch('from'),
        Watch('to'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], PaymentTransactionsComponent.prototype, "fetchData", null);
    PaymentTransactionsComponent = __decorate([
        Component({
            name: 'corex-payment-transactions',
            methods: { getItemDate: getItemDate, getItemTime: getItemTime },
            store: store,
            filters: {
                formatCurrency: formatCurrency,
                toUtc: toUtc,
                formatTime: formatTime,
                formatTimeUTC: formatTimeUTC,
                formatDate: formatDate,
            },
        })
    ], PaymentTransactionsComponent);
    return PaymentTransactionsComponent;
}(Mixins(MagicConfigMixin, ContentMixin)));

export default PaymentTransactionsComponent;
export { PaymentHistoryType };
